import store from "../../../../../store";
import {changeResource, deleteAllResources} from "../../../../../actions/sqftResourceFunctions";
import {deleteAllMiteredSections} from "../../../../../actions/sqftMiteredFunctions";
import workspace from "../core/workspace";
import {RESOURCE_TYPE} from "../../../constants";

const sqftResourcesManager = {
  deleteAllResources: () => {
    store.dispatch(deleteAllResources());
  },
  deleteAllMiteredSections: () => {
    const reduxState = store.getState();
    const miteredSections = reduxState.sqftMiteredState.miteredSections;
    if (miteredSections.length) {
      store.dispatch(deleteAllMiteredSections());
    }
  },
  getAttachedToLineResource: (line) => {
    return workspace.getAttachedTo(line)
  },
  updateAttachedToLineResource: (attachedToResource) => {
    store.dispatch(changeResource(RESOURCE_TYPE.attachedToLine, attachedToResource));
  },
  getLineByAttachedItemId: (id) => {
    const state = store.getState();
    const attachedToLineResources = state.sqftResourceState.attachedToLine;
    const attachedItem = attachedToLineResources.find(attachedToLine => attachedToLine.id === id);
    if (attachedItem) {
      return workspace.getLineById(attachedItem.attachedToId);
    }
  },
  deleteAttachedItemById: (id) => {
    const line = sqftResourcesManager.getLineByAttachedItemId(id);

    if (line) {
      line.deleteAttachedItem();
    }
  }
}

export default sqftResourcesManager
